import getStories, { ResGetStories } from '@/service/story/getStories';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RQStoryKey } from './RQStoryKey';

export const useStoriesInfiniteQuery = () => {
  return useInfiniteQuery<ResGetStories, Error>({
    queryKey: RQStoryKey['stories'],
    queryFn: async ({ pageParam = 0 }) => {
      const params = pageParam === 0 ? {} : { lastId: pageParam as number };

      return await getStories(params);
    },
    getNextPageParam: (lastPage) => {
      const { content, last } = lastPage.result;
      if (last) return undefined; // ✅ 더 이상 불러올 데이터가 없으면 undefined

      const lastProduct = content[content.length - 1];
      return lastProduct?.id || undefined;
    },
    initialPageParam: 0,
  });
};
